import { userRule, whiteNavs, hasBottomUrls, MODE, _ENUM_MICRO } from '@/utils'
import { checkProductOpenStatus } from '@/api/user'
import router from '@/router'

export const toRegisterPage = () => {
  let { href, pathname, search } = location
  if ([`${userRule}/register`].includes(pathname)) {
    return
  }
  router.push(`${userRule}/register${search}`)
}

// 跳转到首页
export const toHomePage = () => {
  location.href = `${userRule}/register`
}

// 是否是浏览器环境
export function hasWindow() {
  return typeof window !== 'undefined'
}

// 页面跳转
export async function go2Page({ href, code, isLogin, hasCompany, userInfo, productEnable, productStatus }) {
  const pathname = location.pathname
  const path = await getRightJumpPage({ href, code, isLogin, hasCompany, userInfo, productEnable, productStatus })

  if (path) {
    if (pathname == '/user/register' && pathname == path) return false

    //
    router.push(path)
    return true
  }
  return false
}

// 根据登录、认证企业、开通产品的状态，返回正确的跳转地址
export async function getRightJumpPage({ href, code, isLogin, hasCompany, userInfo, productEnable, productStatus }) {
  // href 没传
  if (!href) return false

  // 白名单过滤
  if (whiteNavs.includes(href)) return href

  // 特殊情况，检查路由是否包含落地页
  const ways = hasBottomUrls[href]
  // 如果没有落地页或未登录跳转到登录页
  const bottomUrl = ways?.notLogin || `${userRule}/register`

  // 未登录
  if (!isLogin) return bottomUrl

  // 不需要认证的href
  let noNeedCompany = ['/track-sh', '/track-sz', '/track-nb', '/schedule', '/accurate', '/route', '/fullLink', '/api', '/freight', '/freight/favorites', '/freight/chart']
  // 未加入企业
  if (!noNeedCompany.includes(href) && !hasCompany) return bottomUrl

  // 没有code默认进入运价
  if (!code) return href

  // 存在code，则进行开通状态校验
  // const resp = await checkProductOpenStatus(code)
  // console.log(code, '开通状态', productStatus[code], '禁用状态', productEnable[code])

  // 未开通产品
  if (!productStatus[code] || productStatus[code] === '未开通') return bottomUrl
  // 产品已禁用
  if (productEnable[code] == -1) return bottomUrl
  // 未提交认证申请
  if (!userInfo.companyName) return bottomUrl
  // 认证中
  if (userInfo.companyStatus === 0) return bottomUrl
  // 驳回认证
  if (userInfo.companyStatus === 10) return bottomUrl
  // 企业被禁用
  if (userInfo.companyStatus === 20 && userInfo.companyEnable === -1) return bottomUrl

  // 已登陆、已认证、已开通
  return ways?.login || href
}

// 根据pathname、登录、认证企业、开通产品的状态，返回正确的跳转地址
export async function getRightJumpPageByPathname({ isLogin, hasCompany }) {
  // 判断是本地开发环境 且 单独启动项目（没有接入qiankun）
  if (MODE === 'dev' && location.port !== '8080') return
  const pathname = location.pathname
  // 如果是白名单，则直接返回
  if (whiteNavs.includes(pathname)) return

  let _code
  let _bottom
  let _noCompany
  // 获取 子应用对应的 code
  pathname.replace(/^\/(rpaStore|cpsqd|cps|agent|api|grab|track|vgm|freight|em|aci|ams|afr|isf|ics|shTrack|wholeLink)(\/(.*))?\/?/, (strMatch, $1, $2, $3) => {
    let { children, ...obj } = _ENUM_MICRO[$1]

    if (children) {
      obj = children[$3] || {}
    }

    let { code, bottom, noCompany } = obj

    _code = code
    _bottom = bottom
    _noCompany = noCompany
  })

  // 未登录、未认证企业
  if (!isLogin) {
    return _bottom
  }

  // 未认证企业
  if (_noCompany !== 'not-need' && !hasCompany) {
    return _bottom
  }

  // 如果code为'' ,则不需要查询是否开通; 如果code存在，则调取接口，获取开通状态
  // 排除track
  if (_noCompany !== 'not-need' && (!_code || (await checkProductOpenStatus(_code)) !== 'ok')) {
    return _bottom
  }
}

// 打开起点qq
export const openQQ = () => {
  window.open('https://wpa1.qq.com/yGWcFLfo?_type=wpa&qidian=true')
}

// 获取浏览器放大倍数
export function getRatio() {
  return Math.round((window.outerWidth / window.innerWidth) * 100)
}

// 获取菜单名称
export function getRouterName(path) {
  // 关于我们
  if (['/about'].includes(path)) return 'about'
  // 用户中心
  if (/^\/user/.test(path)) return 'user'
  // 数据发送落地页
  if (/^\/introduce\/(cps|cpsqd|vgm|ams|em|aci|afr|isf|ics)/.test(path)) return 'send'
  // 海运跟踪落地页
  if (/^\/introduce\/(track|shipping)/.test(path)) return 'shipping'
  // 无忧代理人落地页
  if (/^\/introduce\/(agent)/.test(path)) return 'agent'
  // 抢舱助手落地页
  if (/^\/introduce\/(grab)/.test(path)) return 'grab'
  // openApi
  if (/^\/introduce\/(apistore)/.test(path)) return 'api'
  // 行业动态
  if (/^\/industry\/.*/.test(path)) return 'industry'
  // 首页
  if (/^\/$/.test(path)) return 'home'
  // rpa store
  if (/^\/rpaControl/.test(path)) return 'rpaControl'
  // 上海舱单发送
  if (/^\/cps/.test(path)) return 'send'
  // 青岛舱单发送
  if (/^\/cpsqd/.test(path)) return 'send'
  // vgm
  if (/^\/vgm/.test(path)) return 'send'
  // 无忧代理人
  if (/^\/agent/.test(path)) return 'agent'
  // 抢舱助手
  if (/^\/grab/.test(path)) return 'grab'
  // 海运跟踪
  if (/^\/track/.test(path)) return 'shipping'
  // API超市
  if (/^\/apistore/.test(path)) return 'api'
  // 运价查询
  if (/^\/freight/.test(path)) return 'freight'
  // 海外舱单
  if (/^\/(ams|afr|em|aci|isf|ics)/.test(path)) return 'send'
  // 跟踪
  if (/^\/cargo\/shipping/.test(path)) return 'shipping'
  // 抢舱助手
  if (/^\/cargo\/grab/.test(path)) return 'grab'
  return path
}
